import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=46fdbcd3&lang=pug&"
import script from "./RadioButton.vue?vue&type=script&lang=js&"
export * from "./RadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fdbcd3')) {
      api.createRecord('46fdbcd3', component.options)
    } else {
      api.reload('46fdbcd3', component.options)
    }
    module.hot.accept("./RadioButton.vue?vue&type=template&id=46fdbcd3&lang=pug&", function () {
      api.rerender('46fdbcd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/RadioButton.vue"
export default component.exports